import React from "react";
import { useEffect } from "react";
import { Row, Col, Spinner, Container } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubscriptionDetails } from "../store/slice/subscriptionSlice";

import PostpaidBilling from "../components/subscription/PostpaidBilling";

import { useCmsHook } from "../helpers/cmsHook";
import { CmsConstructor } from "../helpers/cmsConstructor";
import CmsEditAndSave from "../helpers/CmsEditAndSave";

const Subscription = () => {
  const { cmsInstance, setCmsInstance } = useCmsHook();

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { loading, planData } = useSelector(
    (state) => state.subscription.subscription
  );

  useEffect(() => {
    const companyId = searchParams.get("companyId");
    if (companyId) {
      dispatch(fetchSubscriptionDetails(companyId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/subscription") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="subscription-page-bg-container">
      {!cmsInstance ||
      (loading && planData && Object.keys(planData).length > 0) ? (
        <div className="d-flex flex-column justify-content-center align-items-center loading-container">
          <div className="d-flex flex-row justify-content-center align-items-center">
            <Spinner animation="border" variant="success" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <>
          {window.location.pathname === "/subscription" && (
            <div
              className="d-flex flex-row justify-content-center"
              style={{ paddingTop: "50px" }}
            >
              <CmsEditAndSave />
            </div>
          )}

          <Container>
            <Row className="d-flex flex-row justify-content-center">
              <Col xs={12} lg={6}>
                <div className="my-5">
                  <div>
                    {cmsInstance &&
                      cmsInstance.showRichText("cmsContent.subscription.text")}
                  </div>
                  {loading && planData && Object.keys(planData).length > 0 ? (
                    <div className="d-flex flex-column justify-content-center align-items-center loading-container">
                      <div className="d-flex flex-row justify-content-center align-items-center">
                        <Spinner
                          animation="border"
                          variant="success"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <PostpaidBilling />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  );
};

export default Subscription;
